import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      login: "Login",
      loginText: "Please enter your order details",
      loginSuccess: "Successfully logged in",
      accountConfirmed: "Account confirmed",
      confirmingAccount: "Confirming account",
      email: "E-Mail",
      password: "Password",
      confirmPassword: "Confirm password",
      setPassword: "Set password",
      currentPassword: "Current password",
      newPassword: "New password",
      code: "Code",
      logout: "Logout",
      orderNumber: "Order number",
      customerNumber: "Customer number",
      status: "Status",
      deliveryDate: "Delivery date",
      orderDate: "Order date",
      uploadDate: "Upload date",
      openOrder: "Open order",
      order: "Order",
      billingAddress: "Billing Address",
      shippingAddress: "Shipping Address",
      companyName: "Company name",
      street: "Street",
      city: "City",
      phoneNumber: "Phone number",
      zipCode: "Zip code",
      country: "Country",
      positions: "Positions",
      approveText:
        "I hereby confirm that the print data will be sent for production",
      sendPrintdata: "Send printdata",
      checkUploadedImages: "Please check your uploaded files.",

      approve: "Approve",
      approveCorrectText: "I approve the send printdata is correct",
      approvePrintdata: "Approve Printdata",
      printdataApproved: "Printdata approved",
      printdataRejected: "Printdata rejected",
      deleteFile: "Delete this file",
      doNotApprovePrintdata: "Don't approve print data",
      doNotApprove: "Don't approve",
      resolutionTooLow: "resolution too low",
      colorsAreWrong: "colors are wrong",
      other: "other",
      sendToProduction: "Send to production",
      sendSuccess: "Successfully send printdata",
      sendSuccessProduction: "Successfully send printdata to production",
      unsupportedFile: "Unsupported file format",
      unsupportedFileWithName: "Unsupported file format for {{name}}",
      uploadInProgress: "Upload is in progress, please wait",
      quantityUpdated: "Quantity updated",
      positionImageRemoved: "Position image removed",
      quantity: "Quantity",
      remaining: "Remaining",
      downloadAll: "Download all",
      noFiles: "No files to download",
      imageRejected: "Image marked as rejected",
      imageApproved: "Image marked as approved",
      typeInHere: "type in here",
      aspectRatio: "Aspect Ratio",
      aspectRatioFits: "Aspect Ratio fits the product",
      aspectRatioNotFits: "Aspect Ratio doesn't fit",
      dpiTooSmall: "DPI is too small",
      dpiSmall: "DPI is small",
      dpiGood: "DPI is good",
      statusWaiting: "waiting for printdata",
      statusError: "printdata has errors",
      statusUploaded: "printdata uploaded",
      statusReUploaded: "print data re-uploaded",
      statusProduction: "in production",
      statusProductionFinished: "production finished",
      loadMore: "Load more",
      noOrders: "No orders",
      of: "of",
      printDataNotApproved: "Print data was not approved",
      orderNotFound: "Order not found",
      manufacturers: "Manufacturers",
      noManufacturers: "No manufacturers",
      createManufacturer: "Create manufacturer",
      manufacturerId: "Manufacturer ID",
      manufacturerName: "Manufacturer name",
      manufacturerEmail: "Manufacturer email",
      manufacturerCreateSuccess: "Manufacturer successfully created",
      manufacturerCreateFailed: "Failed to create manufacturer",
      createdDate: "Created date",
      edit: "Edit",
      emailExists: "An account with the given email already exists",
      resendEmail: "Resend confirmation email",
      profile: "Profile",
      updateProfile: "Update profile",
      changeEmail: "Change email",
      verifyEmailText: "Check your email to verify",
      verifyingEmail: "Verifying email",
      emailVerified: "Email verified",
      profileUpdated: "Profile updated",
      moreThan1Page: "PDF has more than 1 page",
      invalidPdfPage:
        "one of your pages has an aspect ratio that doesn't fit to any of the ordered products",
      imageDoesNotMatch:
        "Uploaded image does not match the print format, please choose another file",
      positionsNotCompleted: "Positions not completed",
      tooLargeConvertingToImage:
        "The PDF is too large to preview. The file is uploading. In the next step, a preview is generated.",
      imageFullScreen: "Full screen view",
      home: "Home",
      account: "Account",
      minRecommendedDpi: "min. 60 recommended",
      generatingImagePreview: "Generating image preview",
      generatingImagePreviewFew:
        "Generating image preview will take few seconds",
      product: "Product",
      productNumber: "Product number",
      dimension: "Dimension (mm)",
      chooseAnotherFile: "Choose another file",
      approvePrintDataCorrect: "Approve the send printdata to be correct",
      upload: "Upload",
      uploadSuccess: "successfully uploaded",
      userDataDoesNotMatch: "User data does not match. Searched mail: ",
      attachFile: "Attach File",
      attachedFiles: "Attached Files",
      grantReleaseText:
        "The uploaded File contains errors, do you still want to release it and send it to production?",
      grantedReleaseText:
        "The uploaded File contained errors, but production release granted by user",
      grantReleaseFile: "Grant release for this file",
      fullName: "Full Name",
      grantReleaseConfirm:
        "I hereby grant release of this file, with the given errors",
      noDescription: "No description provided",
      imagePreviewDescription:
        "This is just a preview, that does not represent the actual image quality.",
      confirmFile: "Confirm file",
      dpiInfo:
        "The DPI is a unit of measurement for the pixel density of an image file. It is therefore a factor that can be decisive for the quality of a print.",
      ratioInfo:
        "The aspect ratio describes the ratio of width to height of an image. An image with an aspect ratio of 2:1 is twice as wide as it is high.",
      learnMore: "Learn more",
      addDocuments: "Add Documents",
      addDocumentsText:
        "Here you can, if necessary, upload additional documents, such as individual deliverynote, or overview materials",
      attachments: "Attachments",
      attachFiles: "Attach files",
      furtherInformation: "2. Further Information",
      furtherInformationInfo: "Further Information",
      furtherInfoFlowingMotifs:
        "Flowing Motifs (A Motif Running Across Multiple Textile Prints)",
      furtherInfoQualityCheck: "Quality already checked (approved)",
      optional: "optional",
      cutting: "Cutting",
      learnMoreUrl:
        "https://www.pixlip.com/en/navigation/717663aabb9745a8a8446ce6bc266e4a",
      remoteAddress: "Remote Address",
      remoteHost: "Host",
      remotePort: "Port",
      remoteUsername: "Remote Username",
      remotePassword: "Remote Password",
      selectOrDrag: "Select or drag ",
      inFiles: "in files",
      printDataUpload: "1. Print data upload",
      uploadTitle1: "Upload with direct data check",
      uploadContent1: "The data will be checked immediately during the upload.",
      uploadPoint1: " Simple and direct assignment to your ordered prints",
      uploadPoint2: " Start production faster with direct testing",
      uploadPoint3: " High transparency",
      uploadPoint4: " 100% free",
      uploadTitle2: "Data collected to graphics department",
      uploadContent2:
        "The data is uploaded in bulk and sent to our graphics department",
      advantages: "Advantages",
      uploadNow: "Upload Now",
      or: "Or",
      instructions: "Instructions",
      instructionContent:
        "Upload all your print data, the data will then be checked by our graphics team. Please note that the examination can take up to 24 hours.",
      serviceTime: "Service Time",
      uploadTime: "Mon-Fri 8:00am-4:30pm",
      stepsToUpload: "Steps to upload",
      allowedFileformats: "(allowed Fileformats: .pdf,.jpg)",
      uploadStep1: "Select files or drag them into the upload box",
      uploadStep2:
        "Add comments about pressure assignment or other information",
      uploadStep3: "If necessary, upload your own delivery note",
      uploadStep4: "Press “Send files” and transmit print data",
      uploadStep5: "You will receive a confirmation by email",
      uploadStep6:
        "If there are any errors or questions, we will contact you by email. Please also check your spam mailbox",
      itemNumber: "Item number",
      size: "Size",
      fileName: "File name",
      number: "Quantity",
      danger: "Danger!",
      leavePageInformationDelete:
        "When you leave the page, all uploaded files and entered information will be deleted",
      deleteFiles: "Delete files",
      stayOnSide: "stay on side",
      backToSelection: "Back to selection",
      cancel: "Cancel",
      confirm: "Confirm",
      placeHolder: "This is the file for the ",
      commentField: "Comment field",
      uploadOwnDeliveryNote: "Upload your own delivery note",
      deliveryNote: "Upload own custom delivery note",
      uploadData: "Uploaded Data",
      acceptPrintData: "Accept all printdata",
      declinePrintData: "Decline all printdata",
      acceptAllPrintData: "All printdata is accepted",
      declineAllPrintData: "All printdata is declined",
      acceptAllPrintDataWarning:
        "Are you sure, you want to accept all print Data?",
      declineAllPrintDataWarning:
        "Are you sure, you want to decline all print Data?",
      deleteSinglePrintData: "Are you sure, you want to delete the file?",
      productGroup: "Product group",
      filesDeleted: "All files are deleted successfully",
      UploadedDataWarning: "Uploaded data is not available ",
      positionsCompleted: "Position completed",
      thankYouForUploading: "Thank you for uploading your print data!",
      recieveUpdates: "You will recieve Updates via E-Mail",
      happensNext: "What happens next?",
      happensNextStep1: "1. Our Team will check your printdata in detail",
      happensNextStep2:
        "2. We will contact you per mail if anything is wrong with your printdata(please also check spam)",
      happensNextStep3:
        "3. If your printdata is correct, we will send it to production",
      happensNextStep4:
        "4. Your prints are manucatured and send to you within 1-5 Weekdays",
      deliveryNoteLoading:
        "Delivery notes are too large. Fetching the files...",
      deleteOrder: " Delete order",
      deleteOrderTitle: "Do you want to delete this order ?",
      byStatus: "By Status",
      all: "All",
      shippingMethod: "Shipping method",
      productType: "Product-type",
      internalNote: "Internal note",
      manufacturerNote: "Note for manufacturer",
      lastOpened: "Last opened",
      update: "Update",
      isRequired: "is required",
      changelog: "Changelog",
      uploaded: "uploaded",
      printdata: "printdata",
      accepted: "accepted",
      declined: "declined",
      note: "Note",
      file: "File",
      deleted: "deleted",
      delete: "Delete",
      changedTo: "changed to",
      created: "Created",
      noChangeLogs: "No change logs",
      pdfAllowed: "Only PDF format is supported : {{name}}",
      Warning: "See Error",
      orderInReviewMessage:
        "The print data of your order is currently under review",
      orderInProduction:
        "The print data of your order is currently in production",
      noteAfterUpload:
        "The print data is being reviewed again. If errors are found in the print files, you will receive another email. Please continue to monitor your email inbox. Once the order goes into production, you will also receive an email.",
      sendPrintdatah4: "4. Send data",
      orderedQuantityMessage: "Number of ordered products: ",
      uploadedQuantityMessage: "Number of uploaded print templates: ",
      QuantityMessageHigh:
        "The number of uploaded print templates is higher than the number of ordered products.",
      QuantityMessageLow:
        "The number of uploaded print templates is lower than the number of ordered products.",
      QuantityMessageNote:
        "Please write a print assignment and the desired quantity in the comment field of the uploaded files.",
      IncorrectQuantity: "Incorrect Quantity",
      printAssignment: "I confirm that I have added a print assignment.",
      addPrintAssignment: "Add print assignment",
      uploadPrintdata: "Upload Printdata",
      adjustPrintdata: "Adjust Printdata",
      noPrintData: "You have not uploaded any print data yet",
      attention: "Attention",
      shippingAddressChangeText1:
        "The delivery address will be changed for the entire order. If you have ordered hardware that has not yet been manufactured, it will also be sent to the adjusted delivery address.",
      shippingAddressChangeText2:
        "If you have any questions or uncertainties about this, please contact our sales department.",
      updateDeliveryAddress: "Update delivery address",
      whiteNoPrintData: "Positions that do not require print data:",
      fileUploadedSuccessfully: "File uploaded successfully",
      menubar: ["1. Upload Print Data", "2. Further Information", "3. Send data"],
      downloadPrintdatasheet: "Download Print Datasheet",
      faq: "FAQ's: Questions and Answers",
      faqQuestions: [{
        question:
          "The difference between PRINT LIGHT UV and PRINT SUB lies in the printing techniques and materials?",
        answer: "Answer 1",
      },
      {
        question:
          "The difference between PRINT LIGHT UV and PRINT SUB lies in the printing techniques and materials?",
        answer: "Answer 2",
      },
      {
        question:
          "The difference between PRINT LIGHT UV and PRINT SUB lies in the printing techniques and materials?",
        answer: "Answer 3",
      },
      {
        question:
          "The difference between PRINT LIGHT UV and PRINT SUB lies in the printing techniques and materials?",
        answer: "Answer 4",
      }],
      next: "Next",
      HelpSection: "Help Section",
      comment: "Comment",
      viewfile: "View file",
      confirmData: "I hereby confirm that the print data should be transmitted and printed for production",
      tutorialVideo1: "Instructional Video: How to Use the Upload Tool",
      tutorialVideo2: "Instructional Video: How to Prepare Print Files Correctly",
      back: "Back",
      notes: "Additional Notes",
      chooseFile: "Choose file",
      orDrop: "or drop here",
      deliveryNoteFileFormats: "(Allowed Fileformats: .pdf, .csv, .xls, .xlsx)",
      noFurtherInfo: "No further information",
      noDeliveryNoteUploaded: "No delivery note uploaded",
      preparingFiles: "Preparing files",
      selectPages: "Select Pages",
      widthInclTrim: "Width incl. trim (mm)",
      heightInclTrim: "Height incl. trim (mm)",
      page: "Page",
    },
  },
  de: {
    translation: {
      login: "Auftrag suchen",
      loginText: "Bitte geben Sie Ihre Auftragsdaten ein",
      loginSuccess: "Erfolgreich eingeloggt",
      accountConfirmed: "Konto bestätigt",
      confirmingAccount: "Konto bestätigen",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      setPassword: "Passwort festlegen",
      currentPassword: "Jetziges Passwort",
      newPassword: "Neues Passwort",
      code: "Code",
      logout: "Ausloggen",
      orderNumber: "Auftragsnummer",
      customerNumber: "Kundennummer",
      status: "Status",
      deliveryDate: "Lieferdatum",
      orderDate: "Bestelldatum",
      uploadDate: "Datum des Hochladens",
      openOrder: "Offene Bestellung",
      order: "Auftrag",
      billingAddress: "Rechnungsanschrift",
      shippingAddress: "Lieferanschrift",
      companyName: "Firma",
      street: "Straße",
      city: "Stadt",
      phoneNumber: "Telefonnummer",
      zipCode: "Postleitzahl",
      country: "Land",
      positions: "Positionen",
      approveText:
        "Ich bestätige hiermit, dass die Druckdaten zur Produktion übermittelt werden",
      sendPrintdata: "Druckdaten senden",
      sendPrintdatah4: "4. Daten senden",
      approve: "Druckdaten",
      approveCorrectText:
        "Ich bestätige, dass die gesendeten Druckdaten korrekt sind",
      approvePrintdata: "Druckdaten genehmigen",
      printdataApproved: "Druckdaten genehmigt",
      printdataRejected: "Druckdaten abgelehnt",
      doNotApprovePrintdata: "Druckdaten nicht genehmigen",
      doNotApprove: "Nicht genehmigen",
      resolutionTooLow: "Auflösung zu gering",
      colorsAreWrong: "Farben sind falsch",
      other: "Sonstiges",
      sendToProduction: "An die Produktion senden",
      sendSuccess: "Druckdaten erfolgreich gesendet",
      sendSuccessProduction: "Druckdaten erfolgreich an die Produktion senden",
      unsupportedFile: "Nicht unterstütztes Dateiformat",
      unsupportedFileWithName: "Nicht unterstütztes Dateiformat {{name}}",
      uploadInProgress: "Hochladen läuft, bitte warten",
      quantityUpdated: "Menge aktualisiert",
      positionImageRemoved: "Positionsbild entfernt",
      quantity: "Menge",
      remaining: "Verbleibend",
      downloadAll: "Alles herunterladen",
      noFiles: "Keine Dateien zum Herunterladen",
      imageRejected: "Bild als abgelehnt markiert",
      imageApproved: "Bild als genehmigt markiert",
      typeInHere: "hier eintippen",
      aspectRatio: "Seitenverhältnis",
      aspectRatioFits: "Das Seitenverhältnis passt zum Produkt",
      aspectRatioNotFits: "Seitenverhältnis passt nicht",
      dpiTooSmall: "DPI ist zu klein",
      dpiSmall: "DPI ist klein",
      dpiGood: "DPI ist gut",
      statusWaiting: "Warten auf Druckdaten",
      statusError: "Druckdaten sind fehlerhaft",
      statusUploaded: "Druckdaten hochgeladen",
      statusReUploaded: "druckdaten neu hochgeladen",
      statusProduction: "in Produktion",
      statusProductionFinished: "Produktion abgeschlossen",
      loadMore: "Mehr laden",
      noOrders: "keine Befehle",
      of: "von",
      printDataNotApproved: "Druckdaten nicht genehmigt",
      orderNotFound: "Bestellung nicht gefunden",
      manufacturers: "Hersteller",
      noManufacturers: "Keine hersteller",
      createManufacturer: "Hersteller anlegen",
      manufacturerId: "Hersteller ID",
      manufacturerName: "Herstellername",
      manufacturerEmail: "E-Mail des Herstellers",
      manufacturerCreateSuccess: "Hersteller erfolgreich erstellt",
      manufacturerCreateFailed: "Hersteller konnte nicht erstellt werden",
      createdDate: "Erstellungsdatum",
      edit: "Bearbeiten",
      emailExists: "Ein Konto mit der angegebenen E-Mail existiert bereits",
      resendEmail: "Bestätigungsmail erneut senden",
      profile: "Profil",
      updateProfile: "Profil aktualisieren",
      changeEmail: "Ändern Sie die E-Mail",
      verifyEmailText: "Überprüfen Sie Ihre E-Mail zur Bestätigung",
      verifyingEmail: "E-Mail bestätigen",
      emailVerified: "Email überprüft",
      profileUpdated: "Profil aktualisiert",
      moreThan1Page: "PDF hat mehr als 1 Seite",
      QuantityMessageHigh:
        "Die Anzahl der hochgeladenen Druckvorlagen ist höher als die Anzahl der bestellten Produkte.",
      QuantityMessageLow:
        "Die Anzahl der hochgeladenen Druckvorlagen ist niedriger als die Anzahl der bestellten Produkte.",
      QuantityMessageNote:
        "Bitte schreiben Sie eine Druckzuweisung und die gewünschte Anzahl in das Kommentarfeld der hochgeladenen Dateien",
      orderedQuantityMessage: "Anzahl der bestellten Produkte: ",
      uploadedQuantityMessage: "Anzahl der hochgeladenen Druckvorlagen: ",
      invalidPdfPage:
        "eine Ihrer Seiten hat ein Seitenverhältnis, das zu keinem der bestellten Produkte passt",
      imageDoesNotMatch:
        "Das hochgeladene Bild entspricht nicht dem Druckformat, bitte wählen Sie eine andere Datei",
      positionsNotCompleted: "Positionen nicht abgeschlossen",
      tooLargeConvertingToImage:
        "Die PDF ist zu groß um eine Vorschau anzuzeigen. Die Datei wird zunächst hochgeladen, um im nächsten Schritt eine Vorschaudatei zu generieren.",
      imageFullScreen: "Vollbildansicht",
      home: "Heimat",
      account: "Konto",
      minRecommendedDpi: "Mindest. 60 empfohlen",
      generatingImagePreview: "Vorschau wird erstellt",
      generatingImagePreviewFew:
        "Das Generieren der Bildvorschau dauert einige Sekunden",
      product: "Artikel",
      productNumber: "Artikelnummer",
      dimension: "Maße (mm)",
      chooseAnotherFile: "Andere Datei auswählen",
      approvePrintDataCorrect: "Ich genehmige diese Datei für den Druck",
      upload: "Hochladen",
      uploadSuccess: "erfolgreich hochgeladen",
      userDataDoesNotMatch:
        "Nutzerdaten stimmen nicht überein. Gesuchte Mail: ",
      attachFile: "Datei anhängen",
      attachedFiles: "Angehängte Dokumente",
      grantReleaseText:
        "Die hochgeladene Datei enthält Fehler. Möchten Sie sie dennoch freigeben und an die Produktion senden?",
      grantedReleaseText:
        "Die hochgeladene Datei enthielt Fehler, aber die Produktionsfreigabe wurde vom Benutzer erteilt",
      grantReleaseFile: "Erteilen Sie die Freigabe für diese Datei",
      fullName: "Vollständiger Name",
      grantReleaseConfirm:
        "Hiermit erteile ich die Freigabe dieser Datei mit den angegebenen Fehlern",
      noDescription: "Keine Beschreibung angegeben",
      imagePreviewDescription:
        "Dies ist nur eine Vorschau, die nicht die tatsächliche Bildqualität darstellt.",
      confirmFile: "Datei bestätigen",
      dpiInfo:
        "Die DPI ist eine Maßeinheit für die Pixel-dichte einer Bilddatei. Sie ist somit einFaktor der entscheident für die Qualität eines Druckes sein kann.",
      ratioInfo:
        "Das Seitenverhältnis beschreibt das Verhältnis von Breite zu Höhe eine Bildes.Ein Bild mit dem Seitenverhältnis 2:1 ist zweimal so breit, wie es hoch ist.",
      learnMore: "Mehr erfahren",
      addDocuments: "Dokumente hinzufügen",
      addDocumentsText:
        "Hier können Sie, bei Bedarf, weitere Dokumente, wie individuelle Lieferscheine, oder Übersichtsmaterialien hochladen",
      attachments: "Anhänge",
      attachFiles: "Dateien anhängen",
      furtherInformation: "2. Weitere Informationen",
      furtherInfoFlowingMotifs:
        "Übergehende Motive (Ein Motiv, das über Mehrere Textildrucke verläuft)",
      furtherInfoQualityCheck: "Qualität bereits geprüft (Freigabe erteilt)",
      optional: "optional",
      cutting: "Zuschnitt",
      learnMoreUrl:
        "https://www.pixlip.com/service/Tutorials-Webinare/Druckdaten/",
      remoteAddress: "Remote-Adresse",
      remoteHost: "Host",
      checkUploadedImages: "Bitte Überprüfen sie ihre hochgeladen Bilder.",
      remotePort: "Port",
      remoteUsername: "Remote-Benutzername",
      remotePassword: "Remote-Passwort",
      selectOrDrag: "Dateien auswählen",
      inFiles: "oder hineinziehen",
      allowedFileformats: "(erlaubte Dateiformate: .pdf,.jpg)",
      printDataUpload: "1. Druckdatenupload",
      uploadTitle1: "Upload mit direkter Datenprüfung",
      uploadContent1: "Die Daten werden sofort während des Hochladens geprüft.",
      uploadPoint1:
        " Einfache und direkte Zuordnung zu ihren bestellten Drucken",
      uploadPoint2: " Schnellerer Produktionsbeginn durch direkte Prüfung",
      uploadPoint3: " Hohe Transparenz",
      uploadPoint4: " 100% kostenlos",
      uploadTitle2: "Daten gesammelt an Grafikabteilung",
      uploadContent2:
        "Die Daten werden gesammelt hochgeladen und an unsere Grafikabteilung übermittelt",
      advantages: "Vorteile",
      uploadNow: "jetzt hochladen",
      or: "oder",
      instructions: "Anleitung",
      instructionContent:
        "Laden Sie alle Ihre Druckdaten hoch, im Anschluss werden die Daten von unserem Grafikteam geprüft. Bitte beachten Sie, dass die Prüfung bis zu 24 Stunden dauern kann.",
      serviceTime: "Servicezeit",
      uploadTime: "Mo-Fr 8:00-16:30 Uhr",
      stepsToUpload: "Schritte zum Upload",
      uploadStep1: "Datein auswählen oder in die Upload-Box ziehen",
      uploadStep2:
        "Kommentare zur Druckzuweisung oder anderen Informationen hinzufügen",
      uploadStep3: "Bei Bedarf eigenen Lieferschein hochladen",
      uploadStep4: "“Dateien absenden” drücken und Druckdaten übermitteln",
      uploadStep5: "Sie erhalten eine Bestätigung per Mail",
      uploadStep6:
        "Bei Fehlern oder Nachfragen kontaktieren wir Sie per Mail, gucken Sie dazu auch im Spam Postfach nach",
      itemNumber: "Artikelnummer",
      size: "Größe",
      fileName: "Dateiname",
      number: "Anzahl",
      danger: "Achtung!",
      leavePageInformationDelete:
        "Beim Verlassen der Seite werden alle hochgeladenen Datein und eingegebenen Informationen gelöscht",
      deleteFiles: "Dateien löschen",
      stayOnSide: "Auf Seite bleiben",
      backToSelection: "Zurück zur Auswahl",
      cancel: "Stornieren",
      confirm: "Bestätigen",
      placeHolder: "Dies ist die Datei für die",
      commentField: "Kommentarfeld",
      uploadOwnDeliveryNote: "Eigenen Lieferschein hochladen",

      deliveryNote:
        "Laden Sie einen eigenen benutzerdefinierten Lieferschein hoch",
      uploadData: "Hochgeladene Daten",
      deleteFile: "Löschen dieser Datei",
      acceptAllPrintData: "Alle Druckdaten werden akzeptiert",
      declineAllPrintData: "Alle Druckdaten werden abgelehnt",
      acceptAllPrintDataWarning:
        "Sind Sie sicher, dass Sie alle Druckdaten übernehmen möchten?",
      declineAllPrintDataWarning:
        "Sind Sie sicher, dass Sie alle Druckdaten ablehnen möchten?",
      productGroup: "Produktgruppe",
      filesDeleted: "Alle Dateien wurden erfolgreich gelöscht",
      UploadedDataWarning: "Hochgeladene Daten sind nicht verfügbar",
      acceptPrintData: "Akzeptieren Sie alle Druckdaten",
      declinePrintData: "Alle Druckdaten ablehnen",
      positionsCompleted: "Stelle abgeschlossen",
      thankYouForUploading: "Vielen Dank für das Hochladen Ihrer Druckdaten!",
      recieveUpdates: "Sie erhalten Updates per E-Mail",
      happensNext: "Was passiert als nächstes?",
      happensNextStep1: "1. Persönliche Prüfung Ihrer Druckdaten",
      happensNextStep15:"Unser erfahrenes Team prüft Ihre Druckdaten sorgfältig und im Detail.",
      happensNextStep2:"2. Rückmeldung bei Anpassungsbedarf",
      happensNextStep25:"Sollte es Rückfragen oder notwendige Korrekturen geben, informieren wir Sie umgehend per E-Mail. Bitte prüfen Sie ggf. auch Ihren Spam-Ordner.",
      happensNextStep3:"3. Freigabe für die Produktion",
      happensNextStep35:"Sobald Ihre Druckdaten korrekt vorliegen, geben wir den Auftrag direkt in die Produktion.",
      happensNextStep4:"4. Fertigung & Versand",
      happensNextStep45:"Ihre Drucke werden angefertigt und innerhalb von 1–5 Werktagen an Sie versendet.",
      deliveryNoteLoading: "Lieferscheine sind zu groß. Abrufen der Dateien...",
      deleteOrder: " Auftrag löschen",
      deleteOrderTitle: "Möchten Sie diese Bestellung löschen?",
      byStatus: "Nach Status",
      all: "Alle",
      shippingMethod: "Versandart",
      productType: "Produktreihe",
      internalNote: "Interner Hinweis",
      manufacturerNote: "Hinweis für Hersteller",
      lastOpened: "Zuletzt geöffnet",
      update: "Aktualisieren",
      isRequired: "erforderlich",
      changelog: "Änderungsprotokoll",
      uploaded: "hochgeladen",
      printdata: "Druckdaten",
      accepted: "akzeptiert",
      declined: "zurückgegangen",
      note: "Notiz",
      file: "Datei",
      deleted: "gelöscht",
      delete: "Löschen",
      deleteSinglePrintData:
        "Sind Sie sicher, dass Sie die Datei löschen möchten?",
      changedTo: "gewechselt zu",
      created: "Erstellt",
      noChangeLogs: "Keine Änderungsprotokolle",
      pdfAllowed: "Es wird nur das PDF-Format unterstützt : {{name}}",
      orderInReviewMessage:
        "Die Druckdaten Ihrer Bestellung werden derzeit überprüft",
      orderInProduction: "Die Druckdaten Ihrer Bestellung sind in Produktion",
      Warning: "Fehler einsehen",
      noteAfterUpload:
        "Die Druckdaten werden nochmal geprüft. Sollten Fehler in den Druckdateien festgestellt werden, erhalten Sie erneut eine Email. Bitte halten Sie ihr E-Mail Postfach weiter im Blick. Sobald der Auftrag in Produktion geht, erhalten Sie ebenfalls eine E-Mail.",
      IncorrectQuantity: "Fehlerhafte Anzahl",
      printAssignment:
        "Ich bestätige, dass ich eine Druckzuweisung hinzugefügt habe.",
      addPrintAssignment: "Druckzuweisung hinzufügen",
      uploadPrintdata: "Druckdaten hochladen",
      adjustPrintdata: "Druckdaten anpassen",
      noPrintData: "Sie haben noch keine Druckdaten hochgeladen",
      attention: "Achtung",
      shippingAddressChangeText1:
        "Die Lieferadresse wird für den gesamten Auftrag geändert.Sollten Sie Hardware bestellt haben, die noch nicht gefertigt wurde, wird diese ebenfalls an die angepasste Lieferadresse gesendet.",
      shippingAddressChangeText2:
        "Sollten Sie hierzu Fragen oder Unsicherheiten haben, kontaktieren Sie unseren Vertrieb.",
      updateDeliveryAddress: "Lieferaddresse aktualisieren",
      whiteNoPrintData: "Positionen für die keine Druckdaten benötigt werden:",
      fileUploadedSuccessfully: "Datei erfolgreich hochgeladen",
      downloadPrintdatasheet: "Druckdatenblatt herunterladen",
      menubar: ["1. Druckdatenupload", "2. Weitere Informationen", "3. Daten senden"],
      faq: "FAQ's: Fragen und Antworten",
      faqQuestions: [{
        question:
          "Was ist der Unterschied zwischen PRINT LIGHT UV UND PRINT SUB?",
        answer: "Antwort 1",
      },
      {
        question:
          "Was ist der Unterschied zwischen PRINT LIGHT UV UND PRINT SUB?",
        answer: "Antwort 2",
      },
      {
        question:
          "Was ist der Unterschied zwischen PRINT LIGHT UV UND PRINT SUB?",
        answer: "Antwort 3",
      },
      {
        question:
          "Was ist der Unterschied zwischen PRINT LIGHT UV UND PRINT SUB?",
        answer: "Antwort 4",
      }],
      next: "Weiter",
      HelpSection: "Hilfebereich",
      comment: "Kommentar",
      viewfile: "Datei ansehen",
      confirmData: "Ich bestätige hiermit, dass die Druckdaten zur Produktion übermittelt und gedruckt werden sollen",
      tutorialVideo1: "Anleitungsvideo: Wie verwende ich das Uploadtool?",
      tutorialVideo2: "Anleitungsvideo: Wie lege ich Druckdaten richtig an?",
      back: "Zurück",
      notes: "Weitere Anmerkungen",
      chooseFile: "Datei auswählen",
      orDrop: "oder hineinziehen",
      deliveryNoteFileFormats: "(Erlaubte Dateiformate: .pdf, .csv, .xls, .xlsx)",
      furtherInformationInfo: "Weitere Informationen",
      noFurtherInfo: "Keine weiteren Informationen",
      noDeliveryNoteUploaded: "Kein Lieferschein hochgeladen",
      preparingFiles: "Dateien werden vorbereitet",
      selectPages: "Seiten auswählen",
      widthInclTrim: "Breite inkl. Beschnitt (mm)",
      heightInclTrim: "Höhe inkl. Beschnitt (mm)",
      page: "Seite",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "de",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
